module.exports = __webpack_public_path__ + "static/media/tickBox.3c26ef7c.svg";